import { createFileRoute } from '@tanstack/react-router';
import { SupportTicketDetailSheet } from '@/pages/support/detail/support-ticket-detail-sheet';
import { PROTECTED, SUPPORT } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${SUPPORT}`;

export const Route = createFileRoute('/protected/_layout/support/_layout/$id')({
  ...createSheetRouteOptions(RETURN_URL),
  component: () => {
    const { id } = Route.useParams();
    return <SupportTicketDetailSheet ticketId={id} returnUrl={RETURN_URL} />;
  },
});
